<script lang="ts">
	import SettingsRenderer from 'src/components/Settings/shared/SettingsRenderer.svelte';
	import { appSettingsConfig } from 'src/configs/settings/AppSettingsConfig';
</script>

<SettingsRenderer config={appSettingsConfig.legacy} variant="legacy" />
